import React, { useEffect, useRef, useState } from "react";
import ComponentTitle from "../../../Common/ComponentTitle";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Upload,
} from "antd";
import { DeleteOutlined, DownOutlined } from "@ant-design/icons";

import { useLocation, useNavigate } from "react-router-dom";
import { getCategoryDetails } from "../CategoryDetails/CategoryapiFunctions";
import { MdUpload } from "react-icons/md";
import { getAmenityDetails } from "../Amenities/AmenitiesapiFunctions";
import ReactQuill from "react-quill";
import { getCity, getstate } from "../StateCity/StateCityApi";
import { addPlot, deleteImageAPI, editPlot, getPlotDetailsbyId, uploadImageAPI } from "./PlotapiFunctions";

function CreatePlot() {
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const MAX_FILE_SIZE_MB = 25;
  const MAX_FILE_COUNT = 15;
  const location = useLocation();
  const record = location.state?.record;
  const from = location.state?.from;
  const [fileLists, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [PlotData, setPlotData] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  const [updatedList, setUpdatedList] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [amenitiesData, setAmenitiesData] = useState([]);
  const navigate = useNavigate();
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  function FetchPropertiesById() {
    setIsLoading(true);
    getPlotDetailsbyId(`${record.id}`)
      .then((response) => {
        if (response.status) {
          setPlotData(response.data?.data?.PlotData);
          // setCurrentPage(response.data?.pagination?.currentPage);
          // setTotalPages(response.data?.pagination?.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }
  useEffect(() => {
    if (from === "edit" && record.images) {
      const initialFileList = record.images.map((image, index) => ({
        uid: index,
        name: image.imageName,
        status: "done",
        id: image.id,
        url: `${process.env.REACT_APP_IMAGE_URL}${image.imagePath}`,
        thumbnailPath: image.thumbnailPath,
        thumbnailName: image.thumbnailName,
      }));
      setFileList(initialFileList);

      const preselectedThumbnail = initialFileList.find(
        (file) => file.thumbnailPath
      );
      if (preselectedThumbnail) {
        setSelectedThumbnail(preselectedThumbnail.uid);
      }
    }
  }, [from, record]);

  const createPlot = (changedValues) => {
    let formData = new FormData();
    fileLists.forEach((file, index) => {
      formData.append(`files`, file);
    });

    formData.append("categoryId", changedValues.categoryId);
    formData.append("subCategoryId", changedValues.subCategoryId);
    formData.append("description", changedValues.description);
    formData.append("longitude", changedValues.longitude);
    formData.append("latitude", changedValues.latitude);
    formData.append("title", changedValues.title);
    formData.append("type", changedValues.type);
    formData.append("parking", changedValues.parking);
    formData.append("price", changedValues.price);
    formData.append("location", changedValues.location);
    formData.append("listedBy", changedValues.listedBy);
    formData.append("carpetArea", changedValues.carpetArea);
    formData.append("bedrooms", changedValues.bedrooms);
    formData.append("projectName", changedValues.projectName);
    formData.append("bathrooms", changedValues.bathrooms);
    formData.append("floorNo", changedValues.floorNo);
    formData.append("zipCode", changedValues.zipCode);
    formData.append("state", changedValues.state);
    formData.append("leaseType", changedValues.leaseType);
    formData.append("city", changedValues.city);
    formData.append("constructionStatus", changedValues.constructionStatus);
    formData.append("plotArea", changedValues.plotArea);
    formData.append("amenities", JSON.stringify(changedValues.amenities));
    formData.append("bachelorsAllowed", changedValues.bachelorsAllowed);
    formData.append("furnishing", changedValues.furnishing);
    formData.append("address", changedValues.address);
    formData.append("totalFloors", changedValues.totalFloors);

    const payload = {
      categoryId: changedValues.categoryId,
      subCategoryId: changedValues.subCategoryId,
      description: changedValues.description,
      title: changedValues.title,
      type: changedValues.type,
      parking: changedValues.parking,
      price: changedValues.price,
      location: changedValues.location,
      listedBy: changedValues.listedBy,
      carpetArea: changedValues.carpetArea,
      longitude: changedValues.longitude,
      latitude: changedValues.latitude,
      bedrooms: changedValues.bedrooms,
      projectName: changedValues.projectName,
      bathrooms: changedValues.bathrooms,
      floorNo: changedValues.floorNo,
      zipCode: changedValues.zipCode,
      state: changedValues.state,
      leaseType: changedValues.leaseType,
      city: changedValues.city,
      constructionStatus: changedValues.constructionStatus,
      plotArea: changedValues.plotArea,
      amenities: selectedAmenities,
      bachelorsAllowed: changedValues.bachelorsAllowed,
      furnishing: changedValues.furnishing,
      address: changedValues.address,
      totalFloors: changedValues.totalFloors,
      // files: fileLists.forEach((file, index) => {
      //   file;
      // }),
    };
    {
      from === "add"
        ? addPlot(formData)
            .then((response) => {
              if (response.data.success) {
                message.success({ content: response.data.message });
              }
              navigate("/propertiesDetails");
            })
            .catch((error) => {
              console.log(error);
            })
        : editPlot(payload, `${record.id}`)
            .then((response) => {
              if (response.data.success) {
                message.success({ content: response.data.message });
              }

              navigate("/propertiesDetails");
            })
            .catch((error) => {
              console.log(error);
            });
    }
  };

  const props = {
    name: "file",
    accept: ".jpg,.jpeg,.png,.pdf",
    multiple: true,
    beforeUpload: (file) => {
      const isLt25M = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
      if (!isLt25M) {
        message.error(`File must be smaller than ${MAX_FILE_SIZE_MB}MB!`);
        return false;
      }

      if (fileLists.length >= 15) {
        message.error("You can only upload up to 15 files at a time!");
        return false;
      }

      if (from === "edit") {
        const formData = new FormData();
        formData.append("image", file);
        formData.append("PlotId", record.id);

        uploadImageAPI(formData)
          .then((response) => {
            if (response.data.status) {
              const image = response.data.data;

              const newImage = {
                uid: fileLists.length,
                name: image.imageName,
                status: "done",
                id: image.id,
                url: `${process.env.REACT_APP_IMAGE_URL}${image.imagePath}`,
                thumbnailPath: image.thumbnailPath || null,
                thumbnailName: image.thumbnailName || null,
              };

              setFileList((prevList) => [...prevList, newImage]);
              setUpdatedList((prevList) => [...prevList, newImage]);

              message.success("Image uploaded successfully");
            } else {
              message.error("Image upload failed");
            }
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
            message.error("Image upload failed");
          });

        return false;
      }

      setUpdatedList((prevList) => [...prevList, file]);
      return false;
    },
  };

  const handleRemove = (file) => {
    if (file.id) {
      deleteImageAPI(`${file.id}`)
        .then((response) => {
          if (response.data.status) {
            setFileList((prevList) =>
              prevList.filter((item) => item.uid !== file.uid)
            );
            setUpdatedList((prevList) =>
              prevList.filter((item) => item.uid !== file.uid)
            );

            message.success("Image deleted successfully");
          } else {
            message.error("Failed to delete the image");
          }
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
          message.error("Error occurred while deleting the image");
        });
    } else {
      // If it's a newly added file without an ID, just remove it from both lists
      setFileList((prevList) =>
        prevList.filter((item) => item.uid !== file.uid)
      );
      setUpdatedList((prevList) =>
        prevList.filter((item) => item.uid !== file.uid)
      );
    }
  };

  function FetchAmenityDetails(currentPage) {
    getAmenityDetails(`limit=999`)
      .then((response) => {
        if (response.data.status) {
          setAmenitiesData(response.data?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }
  function FetchCategoryDetails(parentId = "") {
    getCategoryDetails(`?type=Plot&categoryId=${parentId}&limit=999`)
      .then((response) => {
        if (response.data.status) {
          if (parentId) {
            setSubCategoryData(response.data?.data[0].subCategories || []);
          } else {
            setCategoryData(response.data?.data || []);
          }
        }
      })
      .catch((err) => {
        console.log("error", err);
        return [];
      });
  }

  useEffect(() => {
    FetchCategoryDetails();
    FetchAmenityDetails();
    if (from === "edit") {
      FetchPropertiesById();
    }
  }, []);

  function handleCategoryChange(categoryId) {
    FetchCategoryDetails(categoryId);
  }
  function handleStateChange(value, id) {
    FetchState(id.id);
  }
  useEffect(() => {
    FetchCategoryDetails();
  }, []);

  // const handleThumbnailChange = (file) => {
  //   if (from === "edit") {
  //     uploadThumbnailAPI(`${file.id}&PlotId=${record.id}`)
  //       .then((response) => {
  //         if (response.data.status) {
  //           setSelectedThumbnail(file.uid);
  //           message.success("Thumbnail uploaded successfully");
  //         } else {
  //           message.error("Thumbnail upload failed");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error uploading Thumbnail:", error);
  //         message.error("Thumbnail upload failed");
  //       });
  //   } else {
  //     setSelectedThumbnail(file.uid);
  //   }
  // };
  function FetchState(stateId = "") {
    setIsLoading(true);
    getstate(`?limit=100`)
      .then((response) => {
        if (response.status) {
          if (stateId) {
            getCity(`limit=9999999`)
              .then((response) => {
                if (response.data.status) {
                  const expandedData = response.data?.data?.cities
                    .filter((item) => item.stateId === stateId)
                    .map((item) => ({
                      ...item,
                    }));

                  setCityData(expandedData || []);
                }
              })
              .catch((err) => {
                console.error("Error fetching cities", err);
              });
            setCityData(response.data?.data[0].cities || []);
          } else {
            setStateData(response?.data.data?.states);
          }
          setStateData(response?.data.data?.states);

          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchState();
  }, []);
  useEffect(() => {
    if (record?.amenities) {
      const prefilledAmenities = record.amenities.map((item) => item.id);
      setSelectedAmenities(prefilledAmenities);
      form.setFieldsValue({ amenities: prefilledAmenities });
    }
  }, [record, form]);

  const handleAmenityChange = (value) => {
    setSelectedAmenities(value);
    form.setFieldsValue({ amenities: value });
  };

  return (
    <div>
      <ComponentTitle
        title={from === "edit" ? "Edit Plot " : "Create Plot Form"}
      />
      <div className="bg-white box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px">
        <Form
          className=" mt-8 font-poppins font-medium text-xs  p-6"
          layout="vertical"
          onFinishFailed={(err) => console.log(err)}
          onFinish={(changedValues) => {
            createPlot(changedValues);
          }}
          ref={formRef}
          form={form}
          initialValues={
            from === "edit"
              ? {
                  categoryId: record.categoryId,
                  description: record.description,
                  title: record.title,
                  subCategoryId: record.subCategoryId,
                  type: record.type,
                  parking: record.parking,
                  price: record.price,
                  location: record.location,
                  listedBy: record.listedBy,
                  carpetArea: record.carpetArea,
                  longitude: record.longitude,
                  latitude: record.latitude,
                  bedrooms: record.bedrooms,
                  totalFloors: record.totalFloors,
                  projectName: record.projectName,
                  bathrooms: record.bathrooms,
                  floorNo: record.floorNo,
                  zipCode: record.zipCode,
                  state: record.state,
                  leaseType: record.leaseType,
                  city: record.city,
                  constructionStatus: record.constructionStatus,
                  plotArea: record.plotArea,
                  amenities: selectedAmenities,
                  bachelorsAllowed: record.bachelorsAllowed === true ? 1 : 0,
                  furnishing: record.furnishing,
                  address: record.address,
                  files: record.images.map((image, index) => ({
                    uid: index,
                    id: image.id,
                    name: image.imageName,
                    status: "done",
                    url: `${process.env.REACT_APP_IMAGE_URL}${image.imagePath}`,
                  })),
                }
              : ""
          }
        >
          <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Col>
              <Form.Item
                name="categoryId"
                label="Category"
                rules={[
                  {
                    required: true,
                    message: "Please Select Category ",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={categoryData.map((i) => ({
                    label: i.categoryName,
                    value: i.id,
                  }))}
                  onChange={(value) => handleCategoryChange(value)}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="subCategoryId"
                label="Sub Category"
                rules={[
                  {
                    required: true,
                    message: "Please Select Sub Category ",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={subCategoryData.map((i) => ({
                    label: i.subCategoryName,
                    value: i.id,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="title"
                label="
                  Title"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Title",
                  },
                ]}
              >
                <Input
                  suffix={
                    <span className="text-sm text-rgbaprimary9 font-normal font-dmsans">
                      0/80
                    </span>
                  }
                  placeholder="Your Plot Title"
                  type="text"
                  className="rounded-none"
                  // className="rounded-none custom-placeholder text-gray2 font-dmsans text-base"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="description"
                label="
                 Description"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Description",
                  },
                ]}
              >
                <ReactQuill
                  theme="snow"
                  className="bg-white"
                  onChange={(value) =>
                    form.setFieldsValue({ description: value })
                  }
                  placeholder="Write your product description here..."
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Col>
              <Form.Item
                name="latitude"
                label="Latitude"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Latitude",
                  },
                  {
                    pattern: /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
                    message: "Please enter a valid latitude between -90 and 90",
                  },
                ]}
              >
                <Input
                  placeholder="Your Plot Latitude"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="longitude"
                label="
                 Longitude"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Longitude",
                  },
                  {
                    pattern: /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
                    message:
                      "Please enter a valid Longitude between -90 and 90",
                  },
                ]}
              >
                <Input
                  placeholder="Your Plot Longitude"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Col>
              <Form.Item
                name="projectName"
                label="Plot Name"
                rules={[
                  {
                    required: true,
                    message: "Please Select Plot Name",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Plot Name"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="type"
                label="Plot Type"
                rules={[
                  {
                    required: true,
                    message: "Please Select Plot Type",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  // defaultValue={formData.installments}

                  options={["Rent", "Sell"].map((i) => ({
                    label: i.toString(),
                    value: i,
                  }))}
                  // onChange={handleSchoolTypeChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="parking"
                label="Parking"
                rules={[
                  {
                    required: true,
                    message: "Please Select Parking ",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  // defaultValue={formData.installments}

                  options={[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({
                    label: i.toString(),
                    value: i,
                  }))}
                  // onChange={handleSchoolTypeChange}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={8}
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 "
          >
            <Col>
              <Form.Item
                name="bedrooms"
                label="Bedrooms"
                rules={[
                  {
                    required: true,
                    message: "Please enter Bedrooms",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid Bedrooms",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Bedrooms"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="bathrooms"
                label="Bathrooms"
                rules={[
                  {
                    required: true,
                    message: "Please enter Bathrooms",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid Bathrooms",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Bathrooms"
                  type="text"
                  className="rounded-none"

                  // className="rounded-none custom-placeholder text-gray2 font-dmsans text-base"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="floorNo"
                label="Floor No"
                rules={[
                  {
                    required: true,
                    message: "Please enter Floor No",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid Floor Number",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Floor No"
                  type="text"
                  // style={{
                  //   width: "97.5%",
                  // }}
                  className="rounded-none"

                  // className="rounded-none custom-placeholder text-gray2 font-dmsans text-base"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="totalFloors"
                label="Total Floors"
                rules={[
                  {
                    required: true,
                    message: "Please enter Total Floors",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enetr valid Total floors",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Total Floors"
                  type="text"
                  // style={{
                  //   width: "97.5%",
                  // }}
                  className="rounded-none"

                  // className="rounded-none custom-placeholder text-gray2 font-dmsans text-base"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="amenities"
                label="Amenities"
                rules={[
                  {
                    required: true,
                    message: "Please Select Amenities",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Select Amenities"
                  value={selectedAmenities} // Controlled value for the Select component
                  onChange={handleAmenityChange} // Handle selection changes
                  options={amenitiesData.map((i) => ({
                    label: i.name,
                    value: i.id,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
            <Col>
              <Form.Item
                name="carpetArea"
                label="Carpet Area"
                rules={[
                  {
                    required: true,
                    message: "Please enter Carpet Area",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid carpet area",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Carpet Area"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="plotArea"
                label="Plot Area"
                rules={[
                  {
                    required: true,
                    message: "Please enter Plot Area",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid Plot area",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Plot Area"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="price"
                label=" Price"
                rules={[
                  {
                    required: true,
                    message: "Please Enter  Price",
                  },
                  {
                    pattern: /^[1-9]\d*(\.\d+)?$/,
                    message: "Please enter a valid price",
                  },
                ]}
              >
                <Input
                  placeholder="Enter  Price"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="leaseType"
                label="Lease Type"
                rules={[
                  {
                    required: true,
                    message: "Please Select Lease Type",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  // defaultValue={formData.installments}

                  options={["Month-to-Month", "Annual", "Short-Term"].map(
                    (i) => ({
                      label: i.toString(),
                      value: i,
                    })
                  )}
                  // onChange={handleSchoolTypeChange}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 ">
            <Col>
              <Form.Item
                name="listedBy"
                label="Listed By"
                rules={[
                  {
                    required: true,
                    message: "Please Select Listed By",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder=""
                  options={["Owner", "Dealer"].map((i) => ({
                    label: i.toString(),
                    value: i,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                suffixIcon={
                  <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                }
                name="constructionStatus"
                label="Construction Status"
                rules={[
                  {
                    required: true,
                    message: "Please select a construction status",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Ongoing"
                  options={[
                    { value: "Done", label: "Done" },
                    { value: "Ongoing", label: "Ongoing" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                suffixIcon={
                  <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                }
                name="furnishing"
                label="Furnished Status"
                rules={[
                  {
                    required: true,
                    message: "Please select a Furnished Status",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Semi Furnished"
                  options={[
                    { value: "Semi Furnished", label: "Semi Furnished" },
                    { value: "Fully Furnished", label: "Fully Furnished" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="bachelorsAllowed"
                label="Bachelors Allowed"
                rules={[
                  {
                    required: true,
                    message: "Please enter Bachelors Allowed or not",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Select..."
                  options={[
                    { value: 1, label: "Allowed" },
                    { value: 0, label: "Not Allowed" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <p className="text-lg font-dmsans font-semibold">Address</p>

          <Divider />
          <Row className="grid grid-cols-1">
            <Col>
              <Form.Item
                name="address"
                label="
                Plot Address"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Address",
                  },
                ]}
              >
                <Input
                  placeholder="Your  Address"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 ">
            <Col>
              <Form.Item
                name="location"
                label="Location"
                rules={[
                  {
                    required: true,
                    message: "Please enter Location",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Location"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                name="state"
                label="State"
                rules={[
                  {
                    required: true,
                    message: "Please Select State",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Select State"
                  options={stateData.map((state) => ({
                    label: state.name,
                    value: state.name,
                    id: state.id,
                  }))}
                  onChange={(value, id) => handleStateChange(value, id)}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="city"
                label="City"
                rules={[
                  {
                    required: true,
                    message: "Please enter a city",
                  },
                  {
                    pattern: /^[a-zA-Z\s-]+$/,
                    message:
                      "City name can only contain letters, spaces, and hyphens",
                  },
                ]}
              >
                <Select
                  suffixIcon={
                    <DownOutlined className="text-sm text-rgbaprimary9 font-normal font-dmsans" />
                  }
                  placeholder="Select a city"
                  options={cityData.map((i) => ({
                    label: i.name,
                    value: i.name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="zipCode"
                label="Zip Code"
                rules={[
                  {
                    required: true,
                    message: "Please enter a ZIP code",
                  },
                  {
                    pattern: /^[1-9][0-9]{5}$/,
                    message: "Please enter a valid 6-digit ZIP code",
                  },
                ]}
              >
                <Input
                  placeholder="Enter ZIP code"
                  type="text"
                  className="rounded-none"
                />
              </Form.Item>
            </Col>
          </Row>

          <div>
            {" "}
            <p className="text-lg font-dmsans font-semibold">Add Images</p>
            <Divider />
            <Row gutter={8} className="flex justify-between">
              <Col>
                <Form.Item name="files" label="Add attachments">
                  <Upload
                    {...props}
                    listType="picture"
                    fileList={updatedList}
                    multiple
                    // onChange={handleUploadChange}
                    onRemove={(file) => handleRemove(file)}
                  >
                    <Button icon={<MdUpload />}>Click to Upload</Button>
                  </Upload>
                </Form.Item>
              </Col>
              {from === "edit" ? (
                <Col>
                  <Form.Item name="thumbnail" label="Set Thumbnail">
                    <div>
                      {fileLists.map((file) => (
                        <div
                          key={file.uid}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <Checkbox
                            checked={selectedThumbnail === file.uid}
                            // onChange={() => handleThumbnailChange(file)}
                          >
                            Set as Thumbnail
                          </Checkbox>

                          <Image
                            src={file.url}
                            alt={file.name}
                            style={{ width: "30px", marginLeft: "10px" }}
                          />

                          <Button
                            danger
                            type="link"
                            onClick={() => handleRemove(file)}
                            style={{ marginLeft: "10px" }}
                          >
                            <DeleteOutlined />
                          </Button>
                        </div>
                      ))}
                    </div>
                  </Form.Item>
                </Col>
              ) : (
                ""
              )}
            </Row>
          </div>

          <Row className="flex justify-between max-w-[96%]">
            <Form.Item>
              <Button
                className="rounded-none p-[0px_32px_0px_32px]   text-sm font-dmsans font-semibold text-gray2 "
                size="large"
                htmlType="onSubmit"
                // onClick={() => setActiveTab("1")}
              >
                Cancel
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                className="rounded-none p-[0px_32px_0px_32px]  text-white font-dmsans font-semibold  bg-rgbaprimary9 text-xs "
                size="large"
                htmlType="submit"
              >
                {from === "edit" ? "Edit" : "Create"}
              </Button>
            </Form.Item>
          </Row>
        </Form>
      </div>
    </div>
  );
}
export default CreatePlot;
